"use client";

import Link from "next/link";
import { Facebook, Linkedin, Youtube } from "lucide-react";

function BriskonMark() {
  return (
    <svg
      viewBox="0 0 34 38"
      aria-hidden="true"
      className="h-10 w-auto sm:h-12"
    >
      <path
        fill="#313eba"
        fillRule="evenodd"
        d="M26.4,4.6c0,2-1.1,3.8-2.9,4.9l-4.2,2.4-2.4,4.2-1.2-2.1-13.4,7.7c-1.3.7-2.2,2-2.3,3.5-.2,1.9.7,3.6,2.3,4.5,1.7,1,3.4,2,5.1,2.9,0-2,1.1-3.8,2.9-4.9l3.9-2.2-1.2-2.1h4.9l13.7-7.9c1.3-.7,2.2-2,2.3-3.5.2-1.9-.7-3.6-2.3-4.5l-5.1-2.9s-.1,0,0,0Z"
      />
      <path
        fill="#313eba"
        fillRule="evenodd"
        d="M21.7,24.8l-2.4,1.4-.5.8-2,3.4-1.2-2.1-3.9,2.2c-.7.4-1.2,1.1-1.4,2-.2,1.2.4,2.2,1.4,2.8l2.3,1.3c1.7,1,3.8,1,5.5,0l2-1.2,9.9-5.7c1.3-.7,2.2-2,2.3-3.5.2-1.9-.7-3.6-2.3-4.5l-5.1-2.9c0,2-1.1,3.8-2.9,4.9l-1.9,1.1s.2,0,.2,0Z"
      />
      <path
        fill="#313eba"
        d="M26.2,4.5l-4.1-2.4h0c-.8-.5-1.6-.9-2.3-1.4-1.7-1-3.8-1-5.5,0-3.8,2.2-7.6,4.4-11.4,6.6C1.1,8.3,0,10.1,0,12.1v1.4H0v4.9S0,19.7,1.3,18.9c.8-.5,2.3-1.4,3.2-2l9.7-5.6-1.2-2.1h4.8l4.2-2.4h0l4.1-2.4h.1Z"
      />
    </svg>
  );
}

export function Footer() {
  const socialLinks = [
    {
      icon: Facebook,
      href: "https://www.facebook.com/BriskonTechnologies",
      label: "Facebook",
    },
    {
      icon: Youtube,
      href: "https://www.youtube.com/@briskontech",
      label: "Youtube",
    },
    {
      icon: Linkedin,
      href: "https://www.linkedin.com/company/briskontechnologies/",
      label: "LinkedIn",
    },
  ];

  return (
    <footer className="bg-black text-white border-t border-white/10">
      <div className="container mx-auto px-4 py-4">
        {/* Top Line: Logo, Text, Socials */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <BriskonMark />
            <span className="hidden sm:inline-block text-[13px] font-medium text-white/80">
              Enterprise-grade auction & procurement technology.
            </span>
          </div>

          <div className="flex items-center gap-3">
            {socialLinks.map(({ icon: Icon, href, label }) => (
              <Link
                key={label}
                href={href}
                aria-label={label}
                className="flex h-8 w-8 items-center justify-center rounded-full border border-[#313eba]/35 text-[#313eba] transition hover:border-[#4ade80] hover:text-[#4ade80]"
              >
                <Icon className="h-4 w-4" />
              </Link>
            ))}
          </div>
        </div>

        {/* Bottom Line: Copyright, Links */}
        <div className="mt-6 flex flex-col sm:flex-row items-center justify-between border-t border-white/10 pt-4 text-[12px] text-white/60">
          <p>© {new Date().getFullYear()} Briskon Technologies Pvt. Ltd. All rights reserved.</p>
          <div className="mt-2 flex gap-6 sm:mt-0">
            <Link href="#" className="hover:text-white transition">Privacy Policy</Link>
            <Link href="#" className="hover:text-white transition">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
